(function ($) {
	/*  ==========================================================================
			PHP Variables
			========================================================================== */

	// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
	// which has been passed in via enqueue-scripts.php

	/*  ==========================================================================
			Grid variables - needed for gridcarousel__init
			========================================================================== */

	// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
	var $grid_sizes = {
		sm: "550",
		md: "700",
		lg: "1000",
		xl: "1200",
		ws: "1400",
		xw: "1600"
	};

	/*  ==========================================================================
			Device Detection - Check if is mobile or ipad
			========================================================================== */

	var isMobile = false; // initiate as false
	var isTouchDevice = !!("ontouchstart" in window);

	if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		isMobile = true;
	}

	var uagent = navigator.userAgent,
		isIE = false;

	if (uagent.indexOf("MSIE") > 0 || uagent.indexOf("Trident") > 0) {
		isIE = true;
	}

	/*  ==========================================================================
			links
			========================================================================== */

	links__init();

	function links__init($context) {
		var $links = $("a").not(".noline, .noline a, .line--added, .sbi_load_btn, .sbi_follow_btn a");

		$links.each(function () {
			var $this = $(this);
			var $icon = $(".fa, .fas, .far, .fal, .fab", $this);

			if ($("img", $this).length < 1) {
				$this.wrapInner("<span class='linkline'>");
				$this.addClass("line--added");
				if ($icon.length > 0) {
					if ($icon.hasClass("fa--left")) {
						$icon.insertBefore($(".linkline", $this));
					} else {
						$icon.insertAfter($(".linkline", $this));
					}
				}
			}
		});
	} // links__init()

	/*  ==========================================================================
			scrolled
			========================================================================== */
	function checkScroll() {
		if ($(window).scrollTop() > 45) {
			$("body").addClass("hasscrolled");
		} else {
			$("body").removeClass("hasscrolled");
		}
	}

	$(window).scroll(function () {
		checkScroll();
	});

	checkScroll();

	/*  ==========================================================================
			sharinglinks
			========================================================================== */

	$(".sharelink--popup").click(function (e) {
		e.preventDefault();
		window.open($(this).attr("href"), "share-dialog", "width=550,height=436");
	});

	/*  ==========================================================================
			accordion
			========================================================================== */

	$(".accordion__question").click(function () {
		$(this).closest(".accordion__item").toggleClass("accordion__item--open");
	});

	/*  ==========================================================================
			Fancybox pop-ups
			========================================================================== */

	Fancybox.bind("[data-fancybox]", {
		Thumbs: false,
		Toolbar: {
			display: [
				{ id: "counter", position: "left" },
				"zoom",
				//"slideshow",
				"fullscreen",
				"close"
			]
		}
	});

	/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts)
			========================================================================== */

	var $grid_carousels = $(".row--carousel .owl-carousel").not(".img-carousel").not(".logo-carousel");

	if ($grid_carousels.length > 0) {
		gridcarousel__init();
	}

	function setOwlStageHeight(event) {
		var $owlStage = event.relatedTarget.$stage,
			activeItems = $owlStage.find(".owl-item.active");

		var maxHeight = 0;
		activeItems.each(function () {
			var thisHeight = $(this).outerHeight();
			maxHeight = maxHeight >= thisHeight ? maxHeight : thisHeight;
		});
		$owlStage.parents(".owl-carousel").css("height", maxHeight);
		$owlStage.parents(".owl-stage-outer").css("height", maxHeight);
	}


	function gridcarousel__init() {
		$grid_carousels.each(function () {
			var $this = $(this);
			var $this_slidecount = $(".col", $this).length;
			if ($this_slidecount > 1) {
				// create resonsive array from col classes
				var classList = $this.find(".col").attr("class").split(/\s+/);
				var responsive_array = {};
				$.each(classList, function (index, item) {
					// if is col width class
					if (item.indexOf("col-") !== -1) {
						var item_width = 0;
						var items_items = 4;
						item = item.replace("col-", "");
						// get min width from col class
						let item_gridsize = item.split("-")[0];
						// check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
						if (isNaN(item_gridsize)) {
							item = item.replace(item_gridsize + "-", "");
							item_width = $grid_sizes[item_gridsize];
						} else {
							item_width = 0;
						}
						// split rest of class into sections (this should now be something like "1-4")
						let item_class_sections = item.split("-");
						// divide second number (e.g 4) by first number (e.g 1) to get number of items
						var item_items = "";
						if (item_class_sections[1]) {
							item_items = item_class_sections[1] / item_class_sections[0];
						} else {
							item_items = 1; // if there isn't a second number it must be a single grid
						}
						responsive_array[item_width] = {
							items: item_items
						};
					}
				});

				$this
					.owlCarousel({
						loop: false,
						nav: true,
						dots: false,
						items: 4,
						navText: ["<i class='fal fa-arrow-left'></i>", "<i class='fal fa-arrow-right'></i>"],
						responsive: responsive_array,
						startPosition: $this_slidecount,
						autoHeight: false,
						onInitialized: setOwlStageHeight,
						onResized: setOwlStageHeight,
						onRefreshed: setOwlStageHeight,
						onTranslated: setOwlStageHeight
					})
					.trigger("refresh.owl.carousel");
			}

			gridcarousel__resize();
		});
	} // gridcarousel__init()

	function gridcarousel__resize() {
		if ($(window).width() <= 550) {
			$(".featuredposts__header__mobile").show();
			var indexToRemove = 0;
			$(".has-optional-description .row--carousel .owl-carousel")
				.trigger("remove.owl.carousel", [indexToRemove])
				.trigger("refresh.owl.carousel");
		}
	}



	/*  ==========================================================================
			effects
			========================================================================== */

	var $effects = $(".effect");

	if ($effects.length > 0) {
		effects__init();
	}

	function effects__init() {
		$effects.each(function () {
			var $el = $(this);
			$el.waypoint({
				handler: function (direction) {
					if (direction === "down") {
						$el.addClass("effect--ready");
					} else {
						$el.removeClass("effect--ready");
					}
				},
				offset: "90%"
			});
		});
	} // effects__init()

	/*  ==========================================================================
			Images gallery
			========================================================================== */

	var $imagesGallery = $(".img-carousel");

	if ($imagesGallery.length > 0) {
		imagesGallery__init();
	}

	function imagesGallery__init() {
		$imagesGallery.each(function () {
			var $this = $(this);
			var $this_slidecount = $(".col", $this).length;
			if ($this_slidecount > 1) {
				// create resonsive array from col classes
				var classList = $this.find(".col").attr("class").split(/\s+/);
				var responsive_array = {};
				$.each(classList, function (index, item) {
					// if is col width class
					if (item.indexOf("col-") !== -1) {
						var item_width = 0;
						var items_items = 4;
						item = item.replace("col-", "");
						// get min width from col class
						let item_gridsize = item.split("-")[0];
						// check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
						if (isNaN(item_gridsize)) {
							item = item.replace(item_gridsize + "-", "");
							item_width = $grid_sizes[item_gridsize];
						} else {
							item_width = 0;
						}
						// split rest of class into sections (this should now be something like "1-4")
						let item_class_sections = item.split("-");
						// divide second number (e.g 4) by first number (e.g 1) to get number of items
						var item_items = "";
						if (item_class_sections[1]) {
							item_items = item_class_sections[1] / item_class_sections[0];
						} else {
							item_items = 1; // if there isn't a second number it must be a single grid
						}
						responsive_array[item_width] = {
							items: item_items,
							dotsEach: true
						};
					}
				});
				$this.owlCarousel({
					loop: false,
					nav: false,
					dots: true,
					items: 4,
					responsive: responsive_array,
					startPosition: $this_slidecount,
					mouseDrag: true,
					touchDrag: true,
					autoHeight: false,
					transitionStyle: "fade"
				});
			}
		}); // gallery__init()
	}

	/*  ==========================================================================
			Client Logo Carousel
			========================================================================== */

	var $logoCarousel = $(".logo-carousel");

	if ($logoCarousel.length > 0) {
		logoCarousel__init();
	}

	function logoCarousel__init() {
		$logoCarousel.each(function () {
			var $this = $(this);
			var $this_slidecount = $(".col", $this).length;
			if ($this_slidecount > 1) {
				// create resonsive array from col classes
				var classList = $this.find(".col").attr("class").split(/\s+/);
				var responsive_array = {};
				$.each(classList, function (index, item) {
					// if is col width class
					if (item.indexOf("col-") !== -1) {
						var item_width = 0;
						var items_items = 4;
						item = item.replace("col-", "");
						// get min width from col class
						let item_gridsize = item.split("-")[0];
						// check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
						if (isNaN(item_gridsize)) {
							item = item.replace(item_gridsize + "-", "");
							item_width = $grid_sizes[item_gridsize];
						} else {
							item_width = 0;
						}
						// split rest of class into sections (this should now be something like "1-4")
						let item_class_sections = item.split("-");
						// divide second number (e.g 4) by first number (e.g 1) to get number of items
						var item_items = "";
						if (item_class_sections[1]) {
							item_items = item_class_sections[1] / item_class_sections[0];
						} else {
							item_items = 1; // if there isn't a second number it must be a single grid
						}
						responsive_array[item_width] = {
							items: item_items,
						};
					}
				});

				$this.owlCarousel({
					loop: true,
					nav: false,
					dots: false,
					items: 4,
					responsive: responsive_array,
					startPosition: $this_slidecount,
					stagePadding: 50,
					mouseDrag: true,
					touchDrag: true,
					autoplay: true,
					autoplayTimeout: 3000,
					//autoplayHoverPause:true,
					autoHeight: false,
					slideTransition: 'linear',
					transitionStyle: "fade",
					smartSpeed: 3000,
					animateIn: 'linear',
					animateOut: 'linear',
				});
			}
		}); // gallery__init()
	}

	/*  ==========================================================================
			pageheader gallery
			========================================================================== */

	var $pageheader__gallery = $(".pageheader__gallery");

	if ($pageheader__gallery.length > 0) {
		gallery__init();
	}

	function gallery__init() {
		$pageheader__gallery.each(function () {
			var $this = $(this);
			var $this_slidecount = $(".pageheader__gallery__img", $this).length;
			if ($this_slidecount > 1) {
				$this.owlCarousel({
					loop: true,
					animateOut: "fadeOut",
					nav: false,
					dots: false,
					items: 1,
					startPosition: $this_slidecount,
					autoHeight: false,
					autoplay: true,
					autoplayTimeout: 7000
				});
			}
		});
	} // gallery__init()

	/*  ==========================================================================
		 VIDEO OPTIONS AND FUNCTIONS
			========================================================================== */

	var controls = [
		"play-large",
		"play", // Play/pause playback
		"progress", // The progress bar and scrubber for playback and buffering
		"current-time", // The current time of playback
		"duration", // The full duration of the media
		"mute"
	];

	// Function that check if element is in viewport
	function isScrolledIntoView(elem) {
		var elementTop = elem.offset().top;
		var elementBottom = elementTop + elem.outerHeight();
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
		return elementBottom > viewportTop && elementTop < viewportBottom;
	}

	// Function updates the position of the play button within  $target to match the position of the mouse
	function updateplayBtnPosition(xMousePos, yMousePos, $target) {
		var videoOffset = $target.offset(),
			videoHeight = $target.height(),
			$playBtn = $target.find(".controls__btn");

		// If mouse is within video frame
		if (videoOffset.top < yMousePos && yMousePos < videoOffset.top + videoHeight) {
			$playBtn.offset({
				left: xMousePos - $playBtn.width() / 2,
				top: yMousePos - $playBtn.height() / 2
			});
			return true;
		} else {
			$playBtn.removeClass("show");
			return false;
		}
	}

	// Function that initialise the listener to follow the mouse position, update the position of the play
	// button and resolve when to show it or hide it
	function init__video__btn($target, player, $playBtn) {
		var initialOffset = $playBtn.offset(),
			lastScrolledTop = 0,
			lastScrolledLeft = 0,
			xMousePos = 0,
			yMousePos = 0;

		if (!isMobile) {
			// Checking if the mouse enters the video area
			$target.mouseenter(function () {
				if (!player.playing && !$playBtn.hasClass("show")) {
					$playBtn.addClass("show");
				}
			});

			// On mouse move make play button follow the mouse
			$(document).mousemove(function (e) {
				var showButton = false;

				xMousePos = e.pageX;
				yMousePos = e.pageY;
				showButton = updateplayBtnPosition(xMousePos, yMousePos, $target);

				//Show button if not in view and video is not playing
				if (!player.playing && !$playBtn.hasClass("show") && showButton) {
					$playBtn.addClass("show");
				}
			});

			// On scroll update the mouse position
			$(document).scroll(function (e) {
				var showButton = false;

				if (lastScrolledLeft !== $(document).scrollLeft()) {
					xMousePos -= lastScrolledLeft;
					lastScrolledLeft = $(document).scrollLeft();
					xMousePos += lastScrolledLeft;
				}
				if (lastScrolledTop !== $(document).scrollTop()) {
					yMousePos -= lastScrolledTop;
					lastScrolledTop = $(document).scrollTop();
					yMousePos += lastScrolledTop;
				}

				showButton = updateplayBtnPosition(xMousePos, yMousePos, $target);

				//Show button if not in view and video is not playing
				if (!player.playing && !$playBtn.hasClass("show") && showButton) {
					$playBtn.addClass("show");
				}
			});

		} else {
			// If it's mobile show button
			$playBtn.addClass("show");
		}
	}

	/*  ==========================================================================
			Homepage: pageheader video
			========================================================================== */

	// Fade in page header video when ready
	if ($(".pageheader--hero").length) {

		var autoplayIframe = document.getElementById('pageheader__video__iframe--autoplay');
		var autoplayPlayer = new Vimeo.Player(autoplayIframe);

		var ctpIframe = document.getElementById('pageheader__video__iframe--clicktoplay');
		var ctpPlayer = new Vimeo.Player(ctpIframe);

		var videoPlaying = false;

		autoplayPlayer.play().then(function () {
			$(".pageheader__video").addClass("pageheader__video--show");
		});

		setTimeout(function () {
			// if video hasnt started playing after 1.5 secs then enable part reveal anyway
			$(".pageheader__video").addClass("pageheader__video--show");
		}, 500);

		$(".pageheader--hero .pageheader__play").click(function () {

			if (!videoPlaying) {
				$(".pageheader--hero").addClass("revealvideo");
				videoPlaying = true;
				setTimeout(function () {
					ctpPlayer.setCurrentTime(0)
					ctpPlayer.setVolume(0.5);
					ctpPlayer.play();
					$(".pageheader--hero").addClass("revealvideo--playing");
				}, 750);
				if (isMobile) {
					launchIntoFullscreen(ctpPlayer);
				}
			} else {
				$(".pageheader--hero").removeClass("revealvideo");
				$(".pageheader--hero").removeClass("revealvideo--playing");
				videoPlaying = false;
				ctpPlayer.setCurrentTime(0)
				ctpPlayer.setVolume(0);
				ctpPlayer.pause();
			}

		});

		ctpPlayer.on('pause', function () {
			$(".pageheader--hero").removeClass("revealvideo");
			$(".pageheader--hero").removeClass("revealvideo--playing");
			videoPlaying = false;
			ctpPlayer.setCurrentTime(0)
			ctpPlayer.setVolume(0);
			ctpPlayer.pause();
		});

		$(".pageheader__play").mouseover(function () {
			$(".pageheader--hero .pageheader__video").addClass("hover");
		})
			.mouseout(function () {
				$(".pageheader--hero .pageheader__video").removeClass("hover");
			});

		// If user scrolls past video pause video
		$(window).scroll(function () {
			if (videoPlaying && isScrolledIntoView($(".pageheader--hero .pageheadervideo")) === false) {
				ctpPlayer.setCurrentTime(0)
				ctpPlayer.pause();
			}
		});

	}

	// Launches video into full screen on play
	function launchIntoFullscreen(element) {
		if (element.requestFullscreen) {
			element.requestFullscreen();
		} else if (element.mozRequestFullScreen) {
			element.mozRequestFullScreen();
		} else if (element.webkitRequestFullscreen) {
			element.webkitRequestFullscreen();
		} else if (element.msRequestFullscreen) {
			element.msRequestFullscreen();
		}
	}


	/*  ==========================================================================
			Shows: pageheader video background
			========================================================================== */

	if ($(".pageheadervideo .plyr__video").length && $(".pageheader--hero").length <= 0) {
		pageheader__video__init();
	}

	function pageheader__video__init() {
		// $(".pageheadervideo__plyr").hide();
		var player = new Plyr($(".pageheadervideo__plyr"), {
			controls: controls,
			fullscreen: { enabled: true, fallback: true, iosNative: true, container: null }
		});

		var $playBtn = $(".pageheader__play .controls__btn");
		var videopaused = false;

		//Setting poster added through the admin
		var poster = $(".pageheadervideo").data("poster");
		player.poster = poster;

		player.on("ready", event => {
			var largePlayButton = $(".pageheadervideo").find(".plyr__control--overlaid");
			largePlayButton.html(
				'<div class="btn__inner"><span>Play Video</span><span>Play Video</span><span>Play Video</span></div>'
			);
		});

		// If video is playing add class to indicate
		player.on("play", function () {
			clearTimeout(videopaused);
			$("body").addClass("pageheader-video-playing");
			// Hide play button
			$playBtn.removeClass("show");
		});

		// If video is paused add a timeout to fadein poster and play button
		player.on("pause", function () {
			videopaused = setTimeout(function () {
				$playBtn.addClass("show");
				$("body").removeClass("pageheader-video-playing");
			}, 4000);
		});

		// If user scrolls past video pause video
		$(window).scroll(function () {
			if (player.playing && isScrolledIntoView($(".pageheader__media")) === false) {
				player.pause();
			}
		});
	}

	/*  ==========================================================================
			Content Module - Video
			========================================================================== */

	if ($(".mediavideo").length && !isIE) {
		mediavideo__init();
	}

	function mediavideo__init() {

		// Setting up all video players for video without autoplay
		var videoplayers = Plyr.setup(".plyr__video", { controls: controls, autopause: false, muted: true });

		// On video is ready add custom play button
		$.each(videoplayers, function (index, player) {
			player.on("ready", event => {
				var $target = $(event.target);
				var largePlayButton = $target.find(".plyr__control--overlaid");
				largePlayButton.html(
					'<div class="btn__inner"><span>Play Video</span><span>Play Video</span><span>Play Video</span></div>'
				);
			});
		});

		// Add listener to pause the video when out of viewport
		$(window).scroll(function () {
			$.each(videoplayers, function (index, player) {
				var $target = $(player.media).parents(".mediavideo");
				if (player.playing && isScrolledIntoView($target) === false) {
					player.pause();
				}
			});
		});

		// Setting up autoplay videos
		$(".mediavideo--autoplay").each(function () {
			var $target = $(this);

			var autoplayiframe = $(this).find("iframe");
			var player = new Vimeo.Player(autoplayiframe);
			player.setVolume(0);

			var videomuted = false,
				videoButtonVisible = true;

			var muteButtonInner =
				"<div class='btn__inner'><span>Mute</span><span>Mute</span><span>Mute</span><span>Mute</span></div>",
				unmuteButtonInner =
					"<div class='btn__inner'><span>Unmute</span><span>Unmute</span><span>Unmute</span><span>Unmute</span></div>";

			var $muteBtn = $(this).find(".controls__btn--unmute");

			if ($muteBtn) {
				$muteBtn.click(function () {
					player.getVolume().then(function (volume) {
						if (volume === 0) {
							player.setVolume(0.5);
							$muteBtn.html(muteButtonInner);
						} else {
							player.setVolume(0);
							$muteBtn.html(unmuteButtonInner);
						}
					});
				});

				$(document).on("mousemove", function () {
					if (!videoButtonVisible) {
						videoButtonVisible = true;
						$muteBtn.addClass("show");

						clearTimeout(videomuted);

						videomuted = setTimeout(function () {
							$muteBtn.removeClass("show");
							videoButtonVisible = false;
						}, 4000);
					}
				});
			}
		});
	}

	/*  ==========================================================================
			AJAX load more / paging
			========================================================================== */

	$(".paging__loadmore").click(function () {
		var button = $(this);
		var data = {
			action: "loadmore",
			query: php_variables.posts, // that's how we get params from wp_localize_script() function
			page: php_variables.current_page
		};
		var button_text; // create variable to store button text

		// This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
		$.ajax({
			url: php_variables.ajax_url, // AJAX handler
			data: data,
			type: "POST",
			beforeSend: function (xhr) {
				button_text = button.html(); // store current button text
				button.text("Loading..."); // change the button text, to let the user know we are loading more posts
			},
			success: function (data) {
				if (data) {
					button.html(button_text); // set back to previous button text
					$(".loadmore-container").append(data); // insert new posts to the loadmore-container, this should be the row that includes the posts
					php_variables.current_page++;
					// if last page, remove the button..
					if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
						button.remove();
					}
					$effects = $(".effect");
					if ($effects.length > 0) {
						effects__init($effects);
					}
					// Re-init links to make sure linklines on newly loaded content still work
					links__init();
				} else {
					button.remove(); // if no data, remove the button as well
				}
			}
		});
	});

	/*  ==========================================================================
			Search open
			========================================================================== */

	// Search open & close
	if ($(".siteheader__search").length) {
		$(".search-toggle").click(function () {
			if ($(this).closest(".siteheader").find(".siteheader__search").hasClass("siteheader__search--open")) {
				$(this).closest(".siteheader").find(".siteheader__search").removeClass("siteheader__search--open");
			} else {
				$(this).closest(".siteheader").find(".siteheader__search").addClass("siteheader__search--open");
				$(this).closest(".siteheader").find(".siteheader__search .searchform__input input").focus();
			}
		});
	}

	// Hide search when clicking anywhere else on the page
	$(document).mouseup(function (e) {
		var search_container = $(".siteheader__search");
		var search_toggle = $(".search-toggle");
		if (
			!search_container.is(e.target) &&
			search_container.has(e.target).length === 0 &&
			!search_toggle.is(e.target) &&
			search_toggle.has(e.target).length === 0
		) {
			$(search_container).removeClass("siteheader__search--open");
		}
	});

	/*  ==========================================================================
			NAVIGATION - mobnav
			========================================================================== */

	var $mobnav = $(".mobnav");
	var $siteheaderbd = $(".siteheader__bd");
	var $mobnavtoggle = $(".mobnav-toggle");
	var mobnavopenclass = "mobnavopen";

	mobnav__init();

	function mobnav__init() {
		// Open mobnav on click the toggle
		$mobnavtoggle.on("click touchend", function (e) {
			e.preventDefault();
			if (!$("body").hasClass(mobnavopenclass)) {
				// IT'S NOT OPEN...
				// var $mobnav_height = window.innerHeight - $siteheaderbd.outerHeight(false);
				// $mobnav.height($mobnav_height);
				$("body").addClass(mobnavopenclass);
			} else {
				// IT'S OPEN...
				// $mobnav.height(0);
				$("body").removeClass(mobnavopenclass);
			}
		});

		// $(window).resize(mobnav__resize);
	} // mobnav__init()

	// On resize check mobnav height is still right
	function mobnav__resize() {
		if ($("body").hasClass(mobnavopenclass)) {
			var $mobnav_height = window.innerHeight - $siteheaderbd.outerHeight(false);
			$mobnav.height($mobnav_height);
		}
	} // mobnav__resize()

	/*  ==========================================================================
			NAVIGATION - mobnav dropdowns
			========================================================================== */

	$(".mobnav .mobnav__section.has-dropdown .mobnav__link").click(function (e) {
		e.preventDefault();
		$(this).closest(".mobnav__section").toggleClass("mobnav__section--open");
	});

	/*  ==========================================================================
			NAVIGATION - sitenav dropdowns
			========================================================================== */

	var $sitenav = $(".sitenav");
	var $sitenavitems = $("li[data-sitenavsection]", $sitenav).not(".hover-avoid");
	var $sitenavdropdown = $(".sitenav__dropdown");
	var $body = $("body");

	var overclass = "sitenav__item--over";
	var navopenbodyclass = "sitenavopen";
	var activesectionclass = "sitenavsection--active";

	var navopen = false;
	var $currentli = false;
	var dropdownclosetimer = false;

	// Check if isMobile, and only init if desktop or Ipad
	if (!isMobile) {
		sitenav__init();
	}

	function sitenav__init() {
		// Check if is touchscreen and setup dropdown to show on tap as well as hover
		if (isTouchDevice) {
			// IF TOUCHSCREEN (e.g. Ipad users)...
			// Setup dropdown to show on tap
			$sitenavitems.on("tap click hover", function (e) {
				$this = $(this);
				e.preventDefault();
				if ($this.hasClass(overclass)) {
					navopen = false;
					sitenav__close();
				} else {
					sitenavsection__open($this);
				}
			});
		} else {
			// IF DESKTOP...
			$sitenavitems.mouseover(sitenavitem__over).mouseout(sitenav__out);
			$sitenavdropdown.mouseover(sitenavsection__over).mouseout(sitenav__out);
		}
	} // sitenav__init()

	function sitenavitem__over() {
		// On hover of sitenav item
		sitenavsection__open($(this));
	} // sitenavitem__over()

	function sitenavsection__open($target_li) {

		var $targetsection = $sitenavdropdown.find(".sitenavsection--" + $target_li.attr("data-sitenavsection"));
		var dropdown_height = $sitenavdropdown.find(".sitenavsection--" + $target_li.attr("data-sitenavsection")).height();

		// Make dropdown show and set classes to say it's open
		$sitenavdropdown.css("height", dropdown_height);
		navopen = true;
		if (dropdownclosetimer) {
			// Clear timeout to stop dropdown closing
			window.clearTimeout(dropdownclosetimer);
		}
		$("." + overclass, $sitenav).removeClass(overclass);
		$target_li.addClass(overclass);
		$body.addClass(navopenbodyclass);
		$currentli = $target_li;
		$("." + activesectionclass).removeClass(activesectionclass);
		$targetsection.addClass(activesectionclass);
	} //sitenavsection__open();

	function sitenavsection__over() {
		// On hover of sitenavsection, keep the dropdown open
		navopen = true;
		if (dropdownclosetimer) {
			// Clear timeout to close the dropdown
			window.clearTimeout(dropdownclosetimer);
		}
		$body.addClass(navopenbodyclass);
	} // sitenavitem__over()

	function sitenav__out() {
		// On leave sitenav hover
		navopen = false;
		// Start timeout to close sitenav dropdown
		dropdownclosetimer = window.setTimeout(sitenav__close, 250);
	} // sitenavitem__over()

	function sitenav__close() {
		// when time out ends and nav open is still false, close the sitenav
		if (!navopen) {
			// Set height to 0 and remove classes
			$("." + activesectionclass).removeClass(activesectionclass);
			$body.removeClass(navopenbodyclass);
			if ($currentli) {
				$currentli.removeClass(overclass);
			}
			$sitenavdropdown.css("height", 0);
		}
	} // sitenav__close

	/*  ==========================================================================
			Polyfill IE11 for forEach
			========================================================================== */

	if ("NodeList" in window && !NodeList.prototype.forEach) {
		NodeList.prototype.forEach = function (callback, thisArg) {
			thisArg = thisArg || window;
			for (var i = 0; i < this.length; i++) {
				callback.call(thisArg, this[i], i, this);
			}
		};
	}

	/*  ==========================================================================
		Posts- Makes post titles the same height.
	========================================================================== */

	/*  ==========================================================================
		FILTERING - Setup shuffle JS for teams.
		========================================================================== */

	if (document.querySelector(".workfilters") !== null) {
		var Shuffle = window.Shuffle;

		class Demo {
			constructor(element) {
				this.element = element.querySelector(".people--grid");
				this.shuffle = new Shuffle(element.querySelector(".people--grid"), {
					itemSelector: ".filtergrid__item",
					sizer: element.querySelector(".my-sizer-element")
				});

				// Log events.
				this.addShuffleEventListeners();
				this._activeFilters = [];
				this.addFilterButtons(element);
			}

			/**
			 * Shuffle uses the CustomEvent constructor to dispatch events. You can listen
			 * for them like you normally would (with jQuery for example).
			 */
			addShuffleEventListeners() {
				this.shuffle.on(Shuffle.EventType.LAYOUT, data => {
					Waypoint.refreshAll();
				});
				this.shuffle.on(Shuffle.EventType.REMOVED, data => {
					Waypoint.refreshAll();
				});
			}

			addFilterButtons(element) {
				const options = element.querySelector(".workfilters");
				if (!options) {
					return;
				}

				const filterButtons = Array.from(options.children);
				const onClick = this._handleFilterClick.bind(this);
				filterButtons.forEach(button => {
					button.addEventListener("click", onClick, false);
					Waypoint.refreshAll();
				});
			}

			_handleFilterClick(evt) {
				const btn = evt.currentTarget;
				const isActive = btn.classList.contains("active");
				const btnGroup = btn.getAttribute("data-group");

				this._removeActiveClassFromChildren(btn.parentNode);

				let filterGroup;
				if (isActive) {
					btn.classList.remove("active");
					filterGroup = Shuffle.ALL_ITEMS;
					Waypoint.refreshAll();
				} else {
					btn.classList.add("active");
					filterGroup = btnGroup;
					Waypoint.refreshAll();
				}

				this.shuffle.filter(filterGroup);
			}

			_removeActiveClassFromChildren(parent) {
				const { children } = parent;
				for (let i = children.length - 1; i >= 0; i--) {
					children[i].classList.remove("active");
					Waypoint.refreshAll();
				}
			}
		}

		document.addEventListener("DOMContentLoaded", () => {
			const peoples = document.querySelectorAll(".module--people-grid");

			peoples.forEach(people => {
				new Demo(people);
			});
		});
	}


	/*  ==========================================================================
		Search toogle
	========================================================================== */

	$(".show-filter__search > span").click(function () {
		$(".show-filter__search > form").animate({
			width: "toggle"
		});
	});

	/*  ==========================================================================
		Talent Section
		========================================================================== */


	var $talent__images = $(".talent__images");

	if ($talent__images.length > 0) {
		talent__images();
	}

	function talent__images() {
		talent_group_count++;
		var $talent__image__group = $(".talent__image__group");
		var talent_group_count = 0;

		$talent__image__group.each(function () {

			var $this = $(this);
			var images = $this.find(".talent__image");
			var len = images.length;
			var image__to__show = 2;
			var inital_delay = 4;
			var initial_limit = 1;
			var continuous_delay = 8;
			let i = 1;

			var limitedInterval = setInterval(() => {
				i++;
				switch__talent__images($this, len);
				if (i > initial_limit) {
					clearInterval(limitedInterval);
					setInterval(() => {
						if (image__to__show > len) {
							image__to__show = 1;
						}
						switch__talent__images($this, len, image__to__show);
						image__to__show++;
					}, continuous_delay * 1000);
				}

			}, inital_delay * 1000);

		});
	} // talent__images()

	function switch__talent__images(talent__group, length, image__to__show = 1) {
		var min = Math.ceil(1);
		var max = Math.floor(length + 1);
		var current_active = parseFloat($(talent__group.find(".talent__image--active")).index()) + 1;

		var randy = Math.floor(Math.random() * (max - min) + min);

		if (current_active === 0) {
			current_active = 1;
		}

		while (current_active === randy) {
			randy = Math.floor(Math.random() * (max - min) + min);
		}

		talent__group.find(".talent__image").removeClass("talent__image--active");
		var image_show = talent__group.find(".talent__image:nth-child(" + image__to__show + ")");
		$(image_show).addClass("talent__image--active");
	} // switch__talent__images()





})(jQuery); // Domready

